import { useState } from "react";
import { adminLogin, setToken, formatApiError } from "@/lib/api";
import { GlassMasthead } from "@/components/GlassMasthead";

export const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { token, user } = await adminLogin(email, password);
      setToken(token);
      onSuccess(user);
    } catch (err) {
      setError(formatApiError(err));
    } finally { setBusy(false); }
  };
  return (
    <div className="admin-root flex items-center justify-center px-6 grain relative" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm relative z-10" data-testid="admin-login-form">
        <GlassMasthead text="ROOTS" dark style={{ fontSize: 72 }} />
        <div className="reader-label mt-2" style={{ opacity: 0.6 }}>Editor sign-in</div>
        <label className="admin-label mt-8">Email</label>
        <input className="admin-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required data-testid="admin-email-input" />
        <label className="admin-label mt-4">Password</label>
        <input className="admin-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required data-testid="admin-password-input" />
        {error && <p className="text-sm mt-3" style={{ color: "#ff8a9b" }} data-testid="admin-login-error">{error}</p>}
        <button className="btn-bordeaux mt-6 w-full justify-center" type="submit" disabled={busy} data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
};
